module.exports = __webpack_public_path__ + "public/img/icon-donasi.379c6e29.png";